import {RoomDoc} from "@/core/api/room.doc.api";
import {RoomDocCanvas} from "@/components/Room/Doc/RoomDocCanvas";
import jsPDF from "jspdf";

export default {
    getRoomDocDrawList: async ({ dispatch, commit, getters, rootGetters }, {docId, docPageId, roomGroupId}) => {
        // store 에 저장하지 않고 core 에서 조회함
        let list = await RoomDoc.getRoomDocDrawList({docId, docPageId, roomGroupId});
        return list;
    },
    changeRoomDocPage: async ({ dispatch, commit, getters, rootGetters }, {docId, docPageId, docPageSeq, roomGroupId}) => {
        await RoomDoc.changeRoomDocFilePage({roomGroupId, docId, docPageId});
        commit('changeRoomDocFilePage', {roomGroupId, docId, docPageId, docPageSeq});
    },
    // uploadRoomDocFile: async ({ dispatch, commit, getters, rootGetters }, {roomGroupId, filename, file, setRoomDoc/*, onUploadProgress*/}) => {
    //     let fileExt = file.name.substring( file.name.lastIndexOf('.')+1 ).toLowerCase();
    //     if(!getters['allowedFileExts'].includes(fileExt)) {
    //         throw new Error('not supported extension, '+ file.name)
    //     }
    //     const id = Date.now();
    //     let uploadObj = {
    //         id, roomGroupId, filename,
    //         total: file.size,
    //         loaded: 0,
    //         percent: 0,
    //         startTime: Date.now()
    //     };
    //     commit('uploadRoomDoc', uploadObj);
    //     await RoomDoc.uploadRoomDoc({roomGroupId, filename, file, setRoomDoc, onUploadProgress: e => {
    //             commit('changeUploadRoomDoc', {
    //                 id,
    //                 loaded: e.loaded
    //             });
    //         }});
    //     // commit
    // },

    uploadRoomDocFile: async({ dispatch, commit, getters, rootGetters }, { file, roomGroupId, filename, setRoomDoc }) => {
        let fileExt = file.name.substring( file.name.lastIndexOf('.')+1 ).toLowerCase();
        if(!getters['allowedFileExts'].includes(fileExt)) {
            throw new Error('not supported extension, '+ file.name)
        }

        const id = Date.now();
        let uploadObj = {
            id, roomGroupId, filename,
            total: file.size,
            loaded: 0,
            percent: 0,
            startTime: Date.now()
        };

        const upload = async () => {
            commit('uploadRoomDoc', uploadObj);

            try{
                await RoomDoc.uploadRoomDoc({roomGroupId, filename, file, onUploadProgress: e => {
                        commit('changeUploadRoomDoc', {
                            id,
                            loaded: e.loaded,
                            percent: e.percent
                        });
                    }});
            }catch(e){
                commit('removeUploadRoomDocFile', uploadObj)
                console.error('Colud not get doc file presigend Url', e);
                return;
            }finally{
                commit('removeUploadRoomDocFile', uploadObj)
            }
        }
        const isImg = new RegExp('(png|jpg|jpeg|bmp|gif)$', 'i');

        if(isImg.test(fileExt)) {
            const resizeImgFile = function(file, callback) {
                if(!file) return;

                const img = new Image()
                img.onerror = function() {
                    callback(file)
                }
                img.onload = function() {
                    URL.revokeObjectURL(this.src)
                    let w = 1920, h = 1080;
                    let ratio = Math.min(w / this.width, h / this.height, 1);
                    if(this.width < w && this.height < h){
                        w = this.width, h = this.height;
                        ratio = 1;
                    }

                    if(file.name.toLowerCase().endsWith('.png')){
                        // pass
                    }else if(file.size < 1024*300){
                        // upload
                        callback(file)
                        return;
                    }
                    w = this.width * ratio;
                    h = this.height * ratio;

                    const cvs = document.createElement('canvas');
                    cvs.width = w;
                    cvs.height = h;
                    const ctx = cvs.getContext('2d');
                    ctx.drawImage(this, 0, 0, w, h);
                    try {
                        URL.revokeObjectURL(this.src)
                    } catch (e) {
                        console.error(e)
                    }
                    cvs.toBlob(function(blob ){
                        blob.name = file.name;
                        file = blob;
                        callback(file)
                    }, 'image/jpeg', 0.9)

                }
                img.src = URL.createObjectURL(file)
            }
            resizeImgFile(file, async (f) => {
                file = f
                await upload()
            })
        } else {
            await upload()
        }

    },
    // requestPresignedUrlForRoomDocFile: async({ dispatch, commit, getters, rootGetters }, { file, roomGroupId, filename }) => {
    //     let fileExt = file.name.substring( file.name.lastIndexOf('.')+1 ).toLowerCase();
    //     if(!getters['allowedFileExts'].includes(fileExt)) {
    //         throw new Error('not supported extension, '+ file.name)
    //     }
    //     const id = Date.now();
    //     let uploadObj = {
    //         id, roomGroupId, filename,
    //         total: file.size,
    //         loaded: 0,
    //         percent: 0,
    //         startTime: Date.now()
    //     };
    //     let res;
    //     try {
    //         res = await RoomDoc.requestPresignedUrlForRoomDocFile();
    //         if(!res.url) {
    //             throw new Error()
    //         }
    //     } catch (e) {
    //         commit('removeUploadRoomDocFile', uploadObj)
    //         console.error('Colud not get doc file presigend Url', e);
    //         return;
    //     }
    //
    //     const {url, storageType} = res;
    //     _.merge(uploadObj, {
    //         url,
    //         storageType,
    //         filesize: file.size,
    //         contentType: file.type,
    //         filename: file.name
    //     } )
    //     try {
    //         let result = await RoomDoc.uploadToPresignedUrl({url, file,
    //             onUploadProgress: e => {
    //                 commit('changeUploadRoomDoc', {
    //                     id,
    //                     loaded: e.loaded
    //                 });}
    //         })
    //         await RoomDoc.completedPresignedUrlRoomDocFile(uploadObj)
    //     }catch (e) {
    //         console.error('Could not upload doc file to Presigned-Url', e)
    //     } finally {
    //         commit('removeUploadRoomDocFile', uploadObj)
    //     }
    // },
    uploadRoomDocFileGroupList: async ({ dispatch, commit, getters, rootGetters }, {roomGroupIds, filename, file, setRoomDoc/*, onUploadProgress*/}) => {
        if(!roomGroupIds || !roomGroupIds.length) {
            return
        }
        let fileExt = file.name.substring( file.name.lastIndexOf('.')+1 ).toLowerCase();
        if(!getters['allowedFileExts'].includes(fileExt)) {
            throw new Error('not supported extension, '+ file.name)
        }
        let uploadObjIds = []
        roomGroupIds.forEach(rg => {
            const id = Date.now();
            uploadObjIds.push(id)
            let uploadObj = {
                id, filename,
                roomGroupId: rg.roomGroupId,
                total: file.size,
                loaded: 0,
                percent: 0,
                startTime: Date.now()
            };
            commit('uploadRoomDoc', uploadObj);
        })

        await RoomDoc.uploadRoomDocFileGroupList({roomGroupIds, filename, file, setRoomDoc, onUploadProgress: e => {
            uploadObjIds.forEach(id => {
                commit('changeUploadRoomDoc', {
                    id,
                    loaded: e.loaded
                });
            })
            }});
        // commit
    },
    removeRoomDocFile: async ({ dispatch, commit, getters, rootGetters }, {roomGroupId, docId}) => {
        await RoomDoc.removeRoomDoc({roomGroupId, docId});
        commit('removeRoomDocFile', {roomGroupId, docId});
    },
    getRoomDocUrl: async ({ dispatch, commit, getters, rootGetters }, {roomGroupId, docId, docPageId, thumbnail}) => {
        let url = await RoomDoc.getRoomDocUrl({roomGroupId, docId, docPageId, thumbnail});
        return url;
    },
    moveRoomDocFilePage: async ({ dispatch, commit, getters, rootGetters }, {roomGroupId, docId, addPage, page}) => {
        let roomDocFile = getters.getRoomDocFile({roomGroupId, docId});

        if(!page){
            page = roomDocFile.currDocPageSeq + addPage;
            if(page > roomDocFile.docFile.docPageCnt){
                page = 1;
            }else if(page < 1){
                page = roomDocFile.docFile.docPageCnt;
            }
        }

        let roomDocFilePage = roomDocFile.pages[page-1];
        dispatch('changeRoomDocPage', {...roomDocFilePage, roomGroupId, docPageSeq: page});
    },
    changeRoomDocSharing: async ({ dispatch, commit, getters, rootGetters }, roomGroupId= 'default') => {
        await RoomDoc.changeRoomDocSharing(roomGroupId);
    },

    createRoomDocPdf: async ({ dispatch, commit, getters, rootGetters }, {roomGroupId, docId, options, listener}) => {
        const roomDocFile = getters.getRoomDocFile({roomGroupId, docId});
        if(!roomDocFile){
            throw 'roomDocFile not found';
        }
        const roomDoc = getters.getRoomDoc({roomGroupId});
        options = Object.assign({
            quality: 100,
            startPage: 1,
            endPage: null,
            progress: ()=>{}
        }, options || {});
        options.withDrawing = options.withDrawing !== false;

        let pgs = 0;
        function setProgress(p){
            if(p === undefined){
                return pgs;
            }

            pgs += p;
            if(pgs > 100){
                pgs = 100;
            }else{
                pgs = parseInt(pgs * 100) / 100;
            }
            listener.onprogress(pgs);
            return pgs;
        }
        setProgress(5);

        // create roomDocCanvas
        const layer = document.createElement('div');
        document.body.append( layer );
        Object.assign(layer.style, {
            'position': 'absolute',
            'left': '0px',
            'top': '0px',
            'width': '1px',
            'height': '1px',
            'opacity': '0',
            'overflow': 'hidden',
            'pointer-events': 'none'
        });

        const RDC = new RoomDocCanvas({
            $el: layer,
            roomDoc: roomDoc
        });
        RDC.init();
        layer.querySelectorAll('canvas').forEach(cvs => {
            cvs.style.pointerEvents = 'none';
        });
        setProgress(5);

        // pdf source data list
        const dataList = await (async () => {
            // 저장할 페이지 파싱 및 datList 에 등록 후 리턴
            const setPage = async (dataList, roomDocPageList, i) => {
                let st = Date.now();
                console.log('# c pdf start :', i);

                let roomDocPage = roomDocPageList[i];
                if(!roomDocPage){
                    layer.remove();
                    return Promise.resolve(dataList);
                }

                let imgUrl = await dispatch('getRoomDocUrl', roomDocPage);

                // let marginWidth = 0, marginHeight = 0;
                // if(RoomUI.Doc.data.useMargin){
                //     marginWidth = img.width;
                //     marginHeight = img.height;
                // }
                // // draw canvas
                // layer.style.width = (img.width + marginWidth) + 'px';
                // layer.style.height = (img.height + marginHeight) + 'px';
                // RDC.redraw();

                RDC.csCanvas.clearCanvas(false);
                const img = await RDC.csCanvas.setBackgroundImage(imgUrl);
                let {width, height} = img;

                dataList.size = dataList.size || {width: 0, height: 0};
                dataList.size.width = Math.max(dataList.size.width, width);
                dataList.size.height = Math.max(dataList.size.height, height);

                const { useDocMargin } = rootGetters['roomSetting/roomSetting']
                if (useDocMargin) {
                    width *= 2;
                    height *= 2;
                }

                RDC.csCanvas.size(width, height);
                if(options.withDrawing){
                    const drawList = await dispatch('getRoomDocDrawList', roomDocPage);
                    RDC.setDrawDataList(drawList);
                }

                const dataOptions = {format: 'jpeg'};
                if(options.quality && options.quality < 100){
                    const ratio = options.quality / 100;
                    Object.assign(dataOptions, {
                        canvasWidth: width * ratio,
                        canvasHeight: height * ratio
                    });
                }

                const dataUrl = await RDC.csCanvas.toData(dataOptions);
                //console.log('# c pdf create dataurl :', i, (Date.now() - st)+'ms');st = Date.now();
                dataList.push({
                    width, height, dataUrl
                });
                dataList.dataSize = (dataList.dataSize || 0) + dataUrl.length;

                setProgress(95 / roomDocPageList.length);

                await setPage(dataList, roomDocPageList, i+1);
                return dataList;
            }

            // 대상 page 목록
            const docPageList = await (async () => {
                let docPageList;
                if(roomDocFile.isWhiteboard || !roomDocFile.pages){
                    docPageList = [roomDocFile];
                }else if(
                    (options.startPage && options.startPage !== 1)
                    || options.endPage
                ){
                    docPageList = [];
                    let startPage = options.startPage || 1;
                    let endPage = options.endPage || docPageList.length;
                    for(let i=startPage-1; i<endPage; i++){
                        let page = docPageList[i];
                        if(!page) break;
                        docPageList.push( page );
                    }
                }else{
                    docPageList = await RoomDoc.getRoomDocFilePages(roomDocFile);
                }
                return docPageList;
            })();
            const dataList = await setPage([], docPageList, 0);
            return dataList;
        })();

        // create pdf
        return new Promise((resolve, reject) => {
            // create pdf
            const size = dataList.size;
            const pdfDoc = new jsPDF({
                //orientation: 'landscape', // portrait, landscape
                orientation: size.width < size.height ? 'p' : 'l',
                unit: 'mm',
                format: [100, 100*(size.height/size.width)], //'a4', [297, 210], [size.width, size.height],
                //hotfixes: ['px_scaling']
            }).addMetadata('saved by Gooroomee', '');

            const {width, height} = pdfDoc.internal.pageSize;
            const ratio = Math.min( width/size.width, height/size.height );

            const isBlob = dataList[0].dataUrl instanceof Blob;
            const percent = 100 - setProgress();

            const addPage = (dataList, i) => {
                const data = dataList[i];
                //console.log('# c pdf add page :', i);

                if(i > 0){
                    pdfDoc.addPage();
                }

                let dataUrl = data.dataUrl;
                if(isBlob){
                    dataUrl = URL.createObjectURL(dataUrl);
                }
                try{
                    const compression = jsPDF.API.image_compression.FAST; // NONE, SLOW, MEDIUM, FAST
                    //pdfDoc.addImage(dataUrl, 'PNG', 0, 0, size.width*ratio, size.height*ratio, i, compression);
                    pdfDoc.addImage(dataUrl, 'JPEG', 0, 0, size.width*ratio, size.height*ratio, i, compression);
                }finally{
                    if(isBlob){
                        URL.revokeObjectURL(dataUrl);
                    }
                }

                setProgress(percent / dataList.length);
                //console.log('# c pdf add page end :', i, (Date.now() - stp)+'ms');

                if(i < dataList.length-1){
                    setTimeout(() => {
                        try{
                            addPage(dataList, i+1);
                        }catch(e){reject(e)}
                    }, 0);
                    return;
                }

                setProgress(100);

                let filename = (()=>{
                    function lpad(s){
                        s = ''+s;
                        if(s.length == 2) return s;
                        return '0'+s;
                    }

                    let now = new Date();
                    let dStr = now.getFullYear() + lpad(now.getMonth()+1) + lpad(now.getDate())
                        + lpad(now.getHours()) + lpad(now.getMinutes()) + lpad(now.getSeconds());

                    // options.withDrawing
                    return `grmdoc-${roomDocFile.docName}-${options.withDrawing ? 'draw' : 'ori'}-${dStr}.pdf`;
                })();
                // pdfDoc.save(filename);

                // const blob = pdfDoc.output('blob');
                // blob.filename = filename;
                const buffer = pdfDoc.output('arraybuffer');
                const blob = new Blob([buffer], {filename, type:'application/octet-stream'});
                (() => {
                    const a = document.createElement('a');
                    let url = URL.createObjectURL(blob);
                    try{
                        Object.assign(a, {
                            href: url,
                            download: filename,
                            target: '_blank'
                        });
                        a.click();
                    }finally{
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    }
                })();
                //console.log('# c pdf end :', (Date.now() - st)+'ms');
                resolve({
                    filename: filename,
                    blob: blob
                });
            }
            try{
                addPage(dataList, 0);
            }catch(e){reject(e)}
        });
    },
}
